import styled from 'styled-components'

export const StyledCountingText = styled.span<{ assetFolder?: string }>`
  color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  font-weight: 600;
`
